export const  isValidURL = (str:string) => {
    const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?(\?.*)?$/;
    return regex.test(str);
}

export const mergeArrays = (array1: any[], array2: any[]) => {
    return array1?.map(item1 => {
        // Find the matching item in array2
        const matchingItem = array2?.find(item2 => item2?.id === item1?.prize?.raffleId);

        // Merge objects if a matching item is found, otherwise use item1 as is
        return matchingItem ? { ...item1, ...matchingItem } : item1;
    });
}